import React from "react";
import { TextInput } from "@raketa-cms/raketa-cms";
import RowsInput from "./RowsInput";

const SectionsInput = ({ value, onChange }) => {
  return (
    <React.Fragment>
      <TextInput
        type="text"
        label="Title"
        value={value.title}
        onChange={(title) => onChange({ ...value, title })}
      />

      <RowsInput
        value={value.rows || []}
        onChange={(rows) => onChange({ ...value, rows })}
      />
    </React.Fragment>
  );
};

export default SectionsInput;
